import React, { useEffect, useRef, useState } from 'react';
import './NaverMap.css';
import MapHeader from './MapHeader/MapHeader';
import MarkerClustering from './MarkerClustering';
import api, { clearHotpleCache } from '../../../api';
import SearchHeader from './SearchHeader/SearchHeader';
import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import { haversineDistance, openInstagramMedia, shareContent } from '../../../util';
import ShopHeader from './ShopHeader/ShopHeader';


const { naver } = window;

const NaverMap = ({ account, activeMenu, setActiveMenu, selectedOption, setSelectedOption, myHotples, adminHotples, mapHotples, setRangeHotples, setRecommendHotples, mapLocation, setMapLocation, isSearchMode, setIsSearchMode, selectedHotple, setSelectedHotple, setInfoModalPage, periodHotpleGroup, marginTop, platform, devicePosition, setDevicePosition, perm, setUserModalPage, hotThreshold, shopItems, setIsHotModalShown, setAuthModalPage, setAnlysisPageHotple, setModalProps}) => {
  const mapElement = useRef(null);
  const [initialRender, setInitialRender] = useState(true);
  const [isMapLoad, setIsMapLoad] = useState(false);
  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [infoWindow, setInfoWindow] = useState(null);
  const [cluster, setCluster] = useState(null);
  const [rangeCircle, setRangeCircle] = useState(null);
  const [deviceMarker, setDeviceMarker] = useState(null);
  const [positionMarker, setPositionMarker] = useState(null);
  const [searchButtonFlag, setSearchButtonFlag] = useState(false);
  const [isLimited, setIsLimited] = useState(false);
  let userZoomChange = false;

  const regionCoordinates = {
    "서울": [37.5666103, 126.9783882],
    "부산": [35.179816, 129.0750223],
    "대구": [35.87139, 128.601763],
    "대전": [36.3504396, 127.3849508],
    "광주": [35.160032, 126.851338],
    "경기": [37.4363177, 127.550802],
    "인천": [37.4562447, 126.7052086],
    "전북": [35.6910153, 127.2368291],
    "전남": [34.9007274, 126.9571667],
    "충북": [36.7853718, 127.6551404],
    "충남": [36.6173379, 126.8453965],
    "경북": [36.6308397, 128.962578],
    "경남": [35.4414209, 128.2417453],
    "강원": [37.8603672, 128.3115261],
    "제주": [33.4273366, 126.5758344],
    "울산": [35.5394773, 129.3112994],
    "세종": [36.4803512, 127.2894325]
};

  useEffect(() => {
    if (!mapElement.current || !naver) return;
    const params = new URLSearchParams(window.location.search);
    const menu = params.get('menu');
    const getRecommendHotpleFlag = params.toString().length == 0 || menu == 'search';
    console.log(getRecommendHotpleFlag);

    const mapOptions = {
      center: new naver.maps.LatLng(37.5695704, 126.978399),
      zoom: 12,
      logoControlOptions: {
        position: naver.maps.Position.BOTTOM_LEFT,
      },
      padding: {top: 100, right: 0, bottom: 100, left: 0},
      disableKineticPan: false,
      // gl: true,
      // customStyleId: 'a72de7ed-7a92-4e90-9837-0790555ffd3d'
    };

    const mapInstance = new naver.maps.Map(mapElement.current, mapOptions);
    setMap(mapInstance);

    // 현재 위치 가져오기
    if (window.flutter_inappwebview) {
      window.setInitialPosition = (lat, long) => {
        const currentLocation = new naver.maps.LatLng(lat, long);

        if(getRecommendHotpleFlag){
          mapInstance.setCenter(currentLocation);
          getRecommendHotple();
        }

        setDevicePosition({ lat, long });
        setIsMapLoad(true);

        delete window.setInitialPosition;
      };

      window.flutter_inappwebview.callHandler('CustomChannel', 'REQUEST_INITIAL_POSITION');
    }
    else{
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            const currentLocation = new naver.maps.LatLng(latitude, longitude);
  
            if(getRecommendHotpleFlag){
              mapInstance.setCenter(currentLocation);
              getRecommendHotple(latitude, longitude);
            }
            
            setDevicePosition({lat:latitude, long:longitude});
            setIsMapLoad(true);
          },
          (error) => {
            console.error('Error fetching geolocation:', error);
            setIsMapLoad(true);
            if(getRecommendHotpleFlag){
              getRecommendHotple();
            }
          },
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0,
          }
        );
      } else {
        console.error('Geolocation is not supported by this browser.');
        setIsMapLoad(true);
      }
    }
    
    document.body.style.overflow = 'hidden';
  }, []);

  function moveToCurrentLocation(){
    if(perm.locationPerm==false)
      setUserModalPage(3);
    else{
      const currentLocation = new naver.maps.LatLng(devicePosition.lat, devicePosition.long);
      if(map.zoom<12)
        map.morph(currentLocation, 12);
      else
        map.panTo(currentLocation)

      if (!mapElement.current || !naver) return;

      if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler('CustomChannel', 'REQUEST_POSITION');
      }
      else{
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              setDevicePosition({lat:latitude, long:longitude});
            },
            (error) => {
              console.error('Error fetching geolocation:', error);
            },
            {
              enableHighAccuracy: true,
              timeout: 5000,
              maximumAge: 0,
            }
          );
        }
      }
    }
  }

  function increaseZoomLevel() {
    if (!mapElement.current || !naver) return;
    
    const currentZoom = map.getZoom();  // 현재 줌 레벨 가져오기
    map.setZoom(currentZoom + 1, { animate: true });      // 줌 레벨 1 증가
  }

  function decreaseZoomLevel() {
    if (!mapElement.current || !naver) return;
    
    const currentZoom = map.getZoom();  // 현재 줌 레벨 가져오기
    map.setZoom(currentZoom - 1, { animate: true });      // 줌 레벨 1 감소
  }

  function getMapRange() {
    const bounds = map.getBounds();

    const southWest = bounds.getSW(); // 남서쪽 좌표 (Latitude, Longitude)
    const northEast = bounds.getNE(); // 북동쪽 좌표 (Latitude, Longitude)
    
    // 좌우 거리 (동서 거리)
    const horizontalDistance = haversineDistance(
      { lat: southWest.lat(), long: southWest.lng() },
      { lat: southWest.lat(), long: northEast.lng() }
    );
    
    // 위아래 거리 (남북 거리)
    const verticalDistance = haversineDistance(
      { lat: southWest.lat(), long: southWest.lng() },
      { lat: northEast.lat(), long: southWest.lng() }
    );
    
    // 더 큰 거리 반환
    return Math.max(horizontalDistance, verticalDistance);
  }

  const clearMarkers = () => {
    markers.forEach(marker => marker.setMap(null));
    setMarkers([]);
  };

  const whenSearchButtonClicked = () => {
    setSearchButtonFlag(false);
    if(activeMenu=='search'){
      getRangeHotple();
    }
    else{
      if(selectedOption.category.startsWith('@'))
        setSelectedOption((prev)=>({...prev, category: 'recommend', sub_category: 'all'}));
      setActiveMenu('search');
    }
  };

  const showHotpleDetail = (hotple) => {
    const { latitude, longitude } = hotple;
    const position = new naver.maps.LatLng(latitude, longitude);

    if (infoWindow) {
      infoWindow.close();
    }

    const newInfoWindow = new naver.maps.InfoWindow({
        content: `
          <div class="infoframe">
            ${
              hotple.media_url
                ? `
                <div class="instagrambutton" data-media-url="${hotple.media_url}">
                  <img class="iconinstagram" alt="" src="images/instagram.svg" />
                  <div class="instagramtext">원본 게시글</div>
                </div>
                <div class="divider"></div>
                `
                : ""
            }
            <a class="analysisbutton">
              <img class="icontexts" alt="" src="images/texts.svg" />
              <div class="instagramtext">핫플 정보</div>
            </a>
          </div>
        `,  // 렌더링된 React 컴포넌트가 포함된 div를 설정
        backgroundColor: "transparent",
        borderColor: "transparent",
        pixelOffset : new naver.maps.Point(0, -41),
        borderWidth: 0,
        disableAnchor: true,
        anchorColor: "#fff",
    });

    naver.maps.Event.addListener(newInfoWindow, 'open', () => {
      setTimeout(()=>{
        //const routeButton = document.querySelector('.routebutton');
        const analysisButton = document.querySelector('.analysisbutton');
        const instagramButton = document.querySelector('.instagrambutton');

        // routeButton.addEventListener('click', () => {  
        //   if (isMobile) {
        //     const naverMapAppUrl = `nmap://route/car?dlat=${hotple.latitude}&dlng=${hotple.longitude}&dname=${hotple.name}&appname=hotple`;
        //     const naverMapAppStoreUrl = isIOS ? `http://itunes.apple.com/app/id311867728?mt=8`:`https://play.google.com/store/apps/details?id=com.nhn.android.nmap`; 

        //     if(platform!='web'){
        //       window.flutter_inappwebview.callHandler('CustomChannel', 'OPEN_NAVER_MAP', naverMapAppUrl, naverMapAppStoreUrl);
        //     }
        //     else{
        //       if(isAndroid){
        //         let fallbackTimer;

        //         const handleVisibilityChange = () => {
        //           if (document.visibilityState === "hidden") {
        //             clearTimeout(fallbackTimer);
        //           }
        //         };

        //         document.addEventListener("visibilitychange", handleVisibilityChange);
        //         window.location.href = naverMapAppUrl;

        //         fallbackTimer = setTimeout(() => {
        //           document.removeEventListener("visibilitychange", handleVisibilityChange);
        //           window.location.href = naverMapAppStoreUrl;
        //         }, 1000);
        //       }
        //       else{
        //         /*let blurFlag = false;
        //         const handleBlur = () => {
        //           blurFlag = true;
        //           window.confirm('aaaa');
        //           window.removeEventListener("blur", handleBlur);
        //         };
        //         window.addEventListener("blur", handleBlur);

        //         let visibilityFlag = false;
        //         const handleVisibilityChange = () => {
        //           if (document.visibilityState === "hidden") {
        //             visibilityFlag = true;
        //           }
        //           window.removeEventListener("visibilitychange", handleVisibilityChange);
        //         };
        //         document.addEventListener("visibilitychange", handleVisibilityChange);*/

        //         // 네이버 지도 앱 실행
        //         window.location.href = naverMapAppUrl;

        //         // Fallback 처리
        //         /*setTimeout(() => {
        //           window.confirm('aaaaaaa');
        //           if (document.visibilityState !== "hidden") {
        //             // 페이지를 떠나지 않았으면 앱 실행 실패로 간주
        //             window.confirm('bbbbbbbbbb');
        //             window.open(naverMapAppStoreUrl);
        //           }
        //         }, 1000); // 적절한 시간으로 설정*/
        //       }
        //     } 
        //   }
        //   else{
        //     const naverMapWebUrl = `https://map.naver.com/v5/directions/${devicePosition.long},${devicePosition.lat},내 위치/${hotple.longitude},${hotple.latitude},${hotple.name}/-/car`;
        //     window.open(naverMapWebUrl, '_blank');
        //   }
        // });

        analysisButton?.addEventListener('click', async () => {
          setAnlysisPageHotple(selectedHotple);
        });

        instagramButton?.addEventListener('click', () => {
          // selectedHotple.media_url 또는 data-media-url 사용
          const url =
            instagramButton.getAttribute('data-media-url') ||
            (typeof selectedHotple !== 'undefined' ? selectedHotple.media_url : '');

          if (!url) return alert('원본 링크가 없습니다.');
          openInstagramMedia(url); // 원하는 함수 호출
        });
      });
    });

    newInfoWindow.open(map, position);
    setInfoWindow(newInfoWindow);
  };

  const whenHotpleSelected = () => {
    showHotpleDetail(selectedHotple);
    setIsSearchMode(false);

    const markerPosition = new naver.maps.LatLng(selectedHotple.latitude, selectedHotple.longitude);

    if(map.zoom<14){
      const offsetLatitude = 600 * 0.000009;
      const newLatitude = markerPosition.lat() - offsetLatitude;
    
      // 새로운 포지션 계산 (경도는 그대로 유지)
      const newPosition = new naver.maps.LatLng(newLatitude, markerPosition.lng());
    
      // `morph`를 사용하여 새로운 위치로 카메라 이동 및 줌 레벨 변경
      map.morph(newPosition, 14, { duration: 500 });
    }
    else{
      const projection = map.getProjection();
      
      const point = projection.fromCoordToOffset(markerPosition);
      
      const newPoint = new naver.maps.Point(point.x, point.y + 90);
    
      const newPosition = projection.fromOffsetToCoord(newPoint);
      map.panTo(newPosition,{duration:500});
    }
  };

  function formatDate(date) {
    const d = new Date(date);
    const currentYear = new Date().getFullYear();
    const year = String(d.getFullYear()).slice(-2);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    
    // 올해와 연도가 같으면 연도를 제외
    return d.getFullYear() === currentYear ? `${month}/${day}` : `${year}/${month}/${day}`;
  }

  const createCustomMarker = (hotple) => {
    const { latitude, longitude, name, main_category, sub_category2, start_date, end_date, created_at, mention_count, has_comment_event, uploaded_at } = hotple;

    const position = new naver.maps.LatLng(latitude, longitude);
    let marker_file="";

    switch(main_category) {
      case "음식점":
        marker_file="restaurant";
        break;
      case "카페디저트":
        marker_file="cafe";
        break;
      case "주점":
        marker_file="alcohol";
        break;
      case "팝업스토어":
        marker_file="popupStore";
        break;
      case "문화예술":
        marker_file="cultural";
        break;
      case "오락액티비티":
        marker_file="activity";
        break;
      case "휴식힐링":
        marker_file="rest";
        break;
      case "숙소":
        marker_file="accommodation";
        break;
      default:
        marker_file="cultural";
    }

    let startDate = '';
    let endDate = '';

    if (start_date) 
      startDate = formatDate(start_date);
    if (end_date)
      endDate = formatDate(end_date);

    const content = `
      <div id='temp-marker' class='parent_marker'>
        ${has_comment_event && uploaded_at && (new Date(uploaded_at) >= new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)) ?
            `<div class='periodBadge'>이벤트</div>`
          :
            start_date && (new Date(start_date) > new Date()) ?
              `<div class='endBadge'>시작예정</div>`
            :
              end_date && (new Date(end_date) < new Date(Date.now())) ?
                  `<div class='endBadge'>종료됨</div>`  
              :
                end_date && (new Date(end_date) < new Date(Date.now() + 3 * 24 * 60 * 60 * 1000)) ?
                  `<div class='periodBadge'>종료임박</div>`
                :
                  mention_count>hotThreshold ?
                    `<div class='hotBadge'>HOT</div>`
                  :
                    new Date(created_at) >= new Date(Date.now() - 7 * 24 * 60 * 60 * 1000) ?
                        `<div class='newBadge'>NEW</div>`
                      :
                        ''
        }
        <div class='div_marker'>
          <p class='p_marker'>${name}</p>
          <p class='p1_marker'>${sub_category2}</p>
          ${startDate!='' || endDate!='' ? `<p class='p2_marker'>${startDate === endDate ? startDate : `${startDate} ~ ${endDate}`}</p>` : ''}
        </div>
        <img class='markercourseAddIcon' alt="" src="images/marker_${marker_file}.png" />
      </div>
    `;

    // 1. content를 임시로 DOM에 추가하여 width 측정
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;
    document.body.appendChild(tempDiv);

    const tempMarker = tempDiv.querySelector('#temp-marker');
    const contentWidth = tempMarker.offsetWidth;

    // 2. content의 width에 따라 anchor 좌표 계산
    const anchorX = contentWidth - 16;

    // 3. 임시 DOM 요소 제거
    document.body.removeChild(tempDiv);

    // 4. naver.maps.Marker 생성
    const marker = new naver.maps.Marker({
      position,
      map,
      icon: {
        content,
        anchor: new naver.maps.Point(anchorX, 43), // 동적으로 계산한 anchorX 값
      },
    });

    marker.hotple_id = hotple.hotple_id;

    naver.maps.Event.addListener(marker, 'click', () => {
      setSelectedHotple(hotple);
    });

    return marker;
  };

  const getRangeHotple = async (lat=null, long=null, range=null) => {
    try {
      setSelectedOption((prev)=>
        ({...prev,
          region: '위치',
          sub_category: 'all'
        }));
      if(isMapLoad){
        let response;
        let latitude, longitude;

        const center = map.getCenter();
        latitude = lat || center.lat();
        longitude = long || center.lng();
        const searchRange = range || getMapRange()/2;

        response = await api.get(`/hotple/range`,{
          params: {
            category: selectedOption.category,
            range: searchRange,
            long: longitude,
            lat: latitude
          }
        });

        drawRangeCircle(latitude, longitude, response.data.range/1000);
        drawPositionMarker(latitude, longitude);
        setIsLimited(response.data.isLimited || !account.hotpleId);
        setRangeHotples(response.data);
        
        const result = await api.get(`/gis/reverse_geocode`,{
          params: {
            lat: latitude,
            long: longitude
          }
        });

        if(result){
          setMapLocation((prev)=>
            ({...prev,
              address: result.data.address,
              latitude: latitude,
              longitude: longitude,
              name: (lat ? mapLocation.name : null )
            }));
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const getRecommendHotple = async (lat=null, long=null) => {
    try {
      const params = new URLSearchParams(window.location.search);
      const hotpleId = params.get('hotple_id');
      const region = params.get('region');
      const category = params.get('category');
      const menu = params.get('menu');
      let response;
      let latitude, longitude;

      latitude = lat || devicePosition.lat;
      longitude = long || devicePosition.long;

      if(menu == 'search'){ //공유 url을 타고 들어온 것이라면
        if(hotpleId){
          setSearchButtonFlag(true);
          response = await api.get(`/hotple/${hotpleId}`);
          if(response.data.hotples.length > 0){
            latitude = response.data.hotples[0].latitude;
            longitude = response.data.hotples[0].longitude;

            setRangeHotples(response.data);
            setTimeout(() => {
              setSelectedHotple(response.data.hotples[0]);
            }, 500);

            const result = await api.get(`/gis/reverse_geocode`,{
              params: {
                lat: latitude,
                long: longitude
              }
            });

            if(result){
              setMapLocation((prev)=>
                ({...prev,
                  address: result.data.address,
                  latitude: latitude,
                  longitude: longitude,
                  name: null
                }));
            }
          }
        }else{
          if(category)
            setSelectedOption((prev)=>({...prev, category: category}));
          if(region)
            setSelectedOption((prev)=>({...prev, region: region}));
        }

        const newUrl = window.location.pathname;
        window.history.replaceState({}, '', newUrl);
      }
      else{
        const searchRange = 30;

        response = await api.get(`/hotple/range`,{
          params: {
            category: selectedOption.category,
            range: searchRange,
            long: longitude,
            lat: latitude
          }
        });

        drawRangeCircle(latitude, longitude, searchRange);
        drawPositionMarker(latitude, longitude);
        setIsLimited(response.data.isLimited || !account.hotpleId);
        setRecommendHotples({ hotples: response.data.hotples.map(v=>[Math.random(),v]).sort((a,b)=>a[0]-b[0]).map(([,v])=>v) });

        setActiveMenu('home')
        if(response.data.hotples.length>0 && map)
          map.morph(new naver.maps.LatLng(devicePosition.lat, devicePosition.long), 12);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const getRegionHotple = async () => {
    try {
      if(isMapLoad){
        const response = await api.get(`/hotple/region`,{
          params: {
            category: selectedOption.category,
            region: selectedOption.region,
          }
        });

        deletePositionMarker();
        deleteRangeCircle();
        setRangeHotples(response.data);
        setIsLimited(response.data.isLimited || !account.hotpleId);

        if(response.data.hotples.length==0){
          const coordinates = regionCoordinates[selectedOption.region];
          const [lat, lng] = coordinates;
          map.morph(new naver.maps.LatLng(lat, lng), 16);
        }
        else
          moveMapToShowAllMarkers(response.data.hotples);

        setMapLocation((prev)=>
          ({...prev,
            name: selectedOption.region
          }));
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const getGroupHotples = async () => {
    try {
      if(isMapLoad){
        const response = await api.get(`/hotple/group`,{
          params: {
            category: selectedOption.category.replace('@',''),
            region: selectedOption.region,
          }
        });

        setMapLocation(
        (prev)=>({...prev,
          name: selectedOption.category.replace('@','')
        }));

        deletePositionMarker();
        deleteRangeCircle();
        setRangeHotples(response.data);

        if(response.data.hotples.length>0)
          moveMapToShowAllMarkers(response.data.hotples);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const moveMapToShowAllMarkers = (hotples) => {
    const bounds = new naver.maps.LatLngBounds();

    let category_kor;
    switch(selectedOption.category) {
      case "cafe":
          category_kor='카페디저트'
          break;
      case "alcohol":
          category_kor='주점'
          break;
      case "restaurant":
          category_kor='음식점'
          break;
      case "popupStore":
          category_kor='팝업스토어'
          break;
      case "cultural":
          category_kor='문화예술'
          break;
      case "activity":
          category_kor='오락액티비티'
          break;
      case "rest":
          category_kor='휴식힐링'
          break;
      case "accommodation":
          category_kor='숙소'
          break;
      default:
          category_kor='추천'
    }

    let filteredHotples = hotples;

    if(selectedOption.region!='전국' && selectedOption.region!='위치')
      filteredHotples = filteredHotples.filter(hotple => hotple.region == selectedOption.region)

    if(selectedOption.category!='recommend' && !selectedOption.category.startsWith('@'))
      filteredHotples = filteredHotples.filter(hotple => hotple.main_category == category_kor)

    filteredHotples.forEach(hotple => {
      if (hotple.latitude != null && hotple.longitude != null) {
        bounds.extend(new naver.maps.LatLng(hotple.latitude, hotple.longitude));
      }
    });

    // 패딩을 주고 경계에 맞춰 카메라 이동
    map.fitBounds(bounds, {
      top: 40, // 패딩 (위쪽)
      right: 40, // 패딩 (오른쪽)
      bottom: 40, // 패딩 (아래쪽)
      left: 40 // 패딩 (왼쪽)
    });
  };

  const drawRangeCircle = (lat, long, radius) => {
    if(map){
      deleteRangeCircle();

      setRangeCircle(new naver.maps.Circle({
        map: map,
        center: new naver.maps.LatLng(lat, long),
        radius: radius*1000,
        strokeColor: '#ff0069',
        strokeWeight: 2,
      }));
    }
  }

  const deleteRangeCircle = () => {
    if(rangeCircle){
      rangeCircle.setMap(null);
      setRangeCircle(null);
      
      const svgElements = document.querySelectorAll('svg'); // 모든 <svg> 태그 선택
      svgElements.forEach(svg => svg.remove()); // 각 <svg> 태그를 순회하며 삭제
    }
  }

  const deletePositionMarker = () => {
    if (positionMarker) {
      positionMarker.setMap(null); // 기존 마커가 존재하면 지도에서 제거
      setPositionMarker(null); // 상태 초기화
      
      const markerElement = document.getElementById('marker');
      if (markerElement) {
        markerElement.remove(); // DOM에서 해당 요소를 제거
      }
    }
  };

  const drawPositionMarker = (lat, long) => {
    if(map){
      deletePositionMarker(); // 기존 마커 삭제

      setPositionMarker(new naver.maps.Marker({
        position: new naver.maps.LatLng(lat, long),
        map: map, // 지도를 가리키는 변수 (props나 state로 전달된 지도를 사용)
        icon: {
          content: `
            <div id="marker" style="
              width: 8px;
              height: 8px;
              background-color: #ff0069;
              border-radius: 50%;
              border: 2px solid white;
              box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
            "></div>
          `,
          anchor: new naver.maps.Point(6, 6) // 마커의 앵커를 중앙으로 설정
        },
        zIndex: 20
      })); // 새로운 마커를 상태에 저장
    }
  };

  const adjustMarkersPosition = (hotples) => {
    const OFFSET = 0.00003;
    const positionMap = {};
  
    hotples.forEach((hotple) => {
      if(hotple.latitude && hotple.longitude){
        const key = `${hotple.latitude.toFixed(6)}_${hotple.longitude.toFixed(6)}`;
        if (!positionMap[key]) {
          positionMap[key] = [];
        }
        positionMap[key].push(hotple);
      }
    });
  
    const adjustedHotples = [];
  
    Object.values(positionMap).forEach((hotpleList) => {
      if (hotpleList.length === 1) {
        adjustedHotples.push(hotpleList[0]);
      } else {
        hotpleList.forEach((hotple, index) => {
          const adjustedHotple = { ...hotple };
          adjustedHotple.latitude += OFFSET * index;  // index에 따라 위치 변경
          adjustedHotple.longitude += OFFSET * index;
          adjustedHotples.push(adjustedHotple);
        });
      }
    });
  
    return adjustedHotples;
  };

  const showMapHotples = (hotples) => {
    if (!map) return;

    clearMarkers();
    const newMarkers = adjustMarkersPosition(hotples).map(hotple => createCustomMarker(hotple));

    setMarkers(newMarkers);

    // 클러스터링 적용
    if (cluster) {
      cluster.setMap(null); // 기존 클러스터 삭제
    }

    const newCluster = new MarkerClustering({
      map: map,
      markers: newMarkers,
      disableClickZoom: false, // 클러스터 클릭 시 줌 인 가능
      gridSize: 100,
      minClusterSize: 3,
      maxZoom: 14,
      icons: [
        {
          content: `<div class="cluster cluster-1"></div>`,
          size: new naver.maps.Size(40, 40),
          anchor: new naver.maps.Point(20, 20)
        },
        {
          content: `<div class="cluster cluster-2"></div>`,
          size: new naver.maps.Size(50, 50),
          anchor: new naver.maps.Point(25, 25)
        },
        {
          content: `<div class="cluster cluster-3"></div>`,
          size: new naver.maps.Size(60, 60),
          anchor: new naver.maps.Point(30, 30)
        }
      ],
      indexGenerator: [5, 10, 20],
      stylingFunction: (clusterMarker, count) => {
        const countDiv = clusterMarker.getElement().querySelector('div');
        if (countDiv) {
          countDiv.textContent = count;
        }
      }
    });

    setCluster(newCluster);
  };

  const updateUserPosition = async () => {
    await api.patch(`/user/position`,
      {
        latitude: devicePosition.lat,
        longitude: devicePosition.long
      }
    );
  };

  const updateDeviceMarker = () => {
    if(map){
      if(deviceMarker==null){
        setDeviceMarker(new naver.maps.Marker({
          position: new naver.maps.LatLng(devicePosition.lat, devicePosition.long),
          map: map, // 지도를 가리키는 변수 (props나 state로 전달된 지도를 사용)
          icon: {
            content: `
              <div id="device_marker" style="
                width: 8px;
                height: 8px;
                background-color: #7638FA;
                border-radius: 50%;
                border: 2px solid white;
                box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
                color: white;
                font-family: Pretendard;
                font-size: 8px;
                text-align: center;
                line-height: 14px;
                font-weight: 800;
              "></div>
            `,
            anchor: new naver.maps.Point(6, 6) // 마커의 앵커를 중앙으로 설정
          },
          zIndex: 10
        })); // 새로운 마커를 상태에 저장
      }
      else
        deviceMarker.position = new naver.maps.LatLng(devicePosition.lat, devicePosition.long);
    }
  };

  useEffect(() => {
    if (!initialRender) {
      if(selectedOption.category.startsWith('@')){  //기간제 그룹 카테고리 선택이라면...
        if(activeMenu!='search')
          setActiveMenu('search');
        else
          getGroupHotples();
      }
      else{
        if(activeMenu=='search')
          if(mapLocation.name == selectedOption.region) //지역 검색 중이라면...
            getRegionHotple();
          else
            getRangeHotple();
        else if(activeMenu=='home')
          getRecommendHotple();
        else if(activeMenu=='my')
          moveMapToShowAllMarkers(myHotples.hotples);
        else if(activeMenu=='admin')
          moveMapToShowAllMarkers(adminHotples.hotples);
      }
    }
    else{
      setInitialRender(false);
    }
  }, [selectedOption.category]);

  useEffect(() => {
    if(selectedOption.region!='위치'){
      if(activeMenu=='search'){
        if(selectedOption.category.startsWith('@'))
          getGroupHotples();
        else
          getRegionHotple();
      }
      else if(activeMenu=='my'){
        setMapLocation((prev)=>
          ({...prev,
            name: selectedOption.region
          }));
        moveMapToShowAllMarkers(myHotples.hotples);
      }
      else if(activeMenu=='admin'){
        setMapLocation((prev)=>
          ({...prev,
            name: selectedOption.region
          }));
        moveMapToShowAllMarkers(adminHotples.hotples);
      }
    }
  }, [selectedOption.region]);

  useEffect(() => {
    if (infoWindow)
      infoWindow.close();

    if(activeMenu=='search'){
      setSelectedOption((prev)=>({...prev, sub_category: 'all'}));
      if(selectedOption.category.startsWith('@'))
        getGroupHotples();
      else if(mapLocation.name == selectedOption.region)
        getRegionHotple();
      else
        getRangeHotple();
    }
    else if(activeMenu=='my'){
      setSelectedOption((prev)=>({...prev, region: '전국', category: 'recommend', sub_category: 'all'}));
      setMapLocation(
        (prev)=>({...prev,
          name: '전국'
        }));
      deleteRangeCircle();
      deletePositionMarker();
      const params = new URLSearchParams(window.location.search);
      const hotpleId = params.get('hotple_id');
      const menu = params.get('menu');
      if(!(menu=="my" && hotpleId))
        moveMapToShowAllMarkers(myHotples.hotples)
    }
    else if(activeMenu=='admin'){
      setSelectedOption((prev)=>({...prev, region: '전국', category: 'recommend', sub_category: 'all'}));
      setMapLocation(
        (prev)=>({...prev,
          name: '전국'
        }));
      deleteRangeCircle();
      deletePositionMarker();
      const params = new URLSearchParams(window.location.search);
      const hotpleId = params.get('hotple_id');
      const menu = params.get('menu');
      if(!(menu=="admin" && hotpleId))
        moveMapToShowAllMarkers(adminHotples.hotples)
    }
    else if(activeMenu=='home'){
      getRecommendHotple();
      setMapLocation(
        (prev)=>({...prev,
          name: '내 주변'
        }));
    }
  }, [activeMenu]);

  useEffect(() => {
    showMapHotples(mapHotples.hotples);
  }, [mapHotples]);

  useEffect(() => {
    if (isMapLoad && map && mapElement && window.flutter_inappwebview) {
      let startTime = Date.now();

      const syncSize = () => {
        const currentTime = Date.now();

        if (currentTime - startTime > 5000)
          return true;

        if (mapElement.current && map) {
          const width = window.innerWidth;
          const height = window.innerHeight;
          const currentSize = map.getSize();

          if (currentSize.width !== width || currentSize.height !== height) {
            map.setSize(new naver.maps.Size(width, height));
            return false;
          }

          return true;
        }

        return false;
      };

      const interval = setInterval(() => {
        const isSynced = syncSize();
        if (isSynced)
          clearInterval(interval);
      }, 100);
    }
  }, [isMapLoad]);

  useEffect(() => {
    if (isMapLoad && map) {
      naver.maps.Event.addListener(map, 'click', () => {
          setIsSearchMode(false);
          setSelectedHotple(null);
          if (infoWindow)
              infoWindow.close();
      });

      naver.maps.Event.addListener(map, 'mousedown', () => {
        userZoomChange = true;
      });

      naver.maps.Event.addListener(map, 'drag', () => {
          setIsSearchMode(false);
          setSearchButtonFlag(true);
          /*setSelectedHotple(null);
          if (infoWindow)
              infoWindow.close();*/
      });

      naver.maps.Event.addListener(map, 'zoom_changed', () => {
        setSearchButtonFlag(true);
        if (userZoomChange) {
          // 사용자에 의해 줌이 변경된 경우만 실행
          setSelectedHotple(null);
          if (infoWindow) {
            infoWindow.close();
          }
          userZoomChange = false; // 플래그 초기화
        }
      });

      naver.maps.Event.addListener(map, 'idle', () => {
        userZoomChange = false;
      });
    }
  }, [isMapLoad]);

  useEffect(() => {
    if (isMapLoad && map) {
      if(mapLocation.name!=null){
        if(mapLocation.name != '내 주변' && !periodHotpleGroup.some(group => group.name === mapLocation.name)){
          if(mapLocation.name != selectedOption.region){  //지역 버튼 선택으로 name이 바뀐 것이 아니라면...
            setIsSearchMode(false);
            const { latitude, longitude } = mapLocation;
            deletePositionMarker();
            map.setZoom(12, false);
            map.panTo(new naver.maps.LatLng(latitude, longitude));
            if(activeMenu=="search")
              getRangeHotple(latitude,longitude,20);
            else if(activeMenu=='my' || activeMenu=='admin')
              drawPositionMarker(latitude, longitude);
          }
          else
            deletePositionMarker();
        }
      }
    }
  }, [mapLocation.name]);

  useEffect(() => {
		if(isSearchMode){
      setSelectedHotple(null);
      if (infoWindow)
        infoWindow.close();
		}
	}, [isSearchMode])

  useEffect(() => {
    if (selectedHotple != null) {
      whenHotpleSelected();

      for(const marker of markers){
        if(marker.hotple_id === selectedHotple.hotple_id)
          marker.setZIndex(100);
        else
          marker.setZIndex(50);
      }
    } else {
      if (infoWindow) infoWindow.close();
    }
  }, [selectedHotple, markers]);

  useEffect(() => {
    if(account.hotpleId && (devicePosition.lat !== 37.5695704 || devicePosition.long !== 126.978399)){
      updateDeviceMarker();
      updateUserPosition();
    }
  }, [devicePosition, account.hotpleId]);

  useEffect(() => {
    clearHotpleCache();
  }, [account.level]);

  useEffect(() => {
    const handleKeyDown = (event) => {
        if (event.key === 'Escape')
          setIsSearchMode(false);
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
        window.removeEventListener('keydown', handleKeyDown);
    };

  }, []);

  return (
    <div ref={mapElement} className="map">
      {activeMenu=='shop' ?
        <ShopHeader account={account} setSelectedOption={setSelectedOption} selectedOption={selectedOption} marginTop={marginTop} shopItems={shopItems} setAuthModalPage={setAuthModalPage} setIsHotModalShown={setIsHotModalShown} setUserModalPage={setUserModalPage} setModalProps={setModalProps}/>
        :
        <MapHeader activeMenu={activeMenu} selectedOption={selectedOption} setSelectedOption={setSelectedOption} setSelectedHotple={setSelectedHotple} mapHotples={mapHotples} mapLocation={mapLocation} setIsSearchMode={setIsSearchMode} setInfoModalPage={setInfoModalPage} setUserModalPage={setUserModalPage} periodHotpleGroup={periodHotpleGroup} marginTop={marginTop} isLimited={isLimited}/>
      }
      {isSearchMode && <SearchHeader selectedOption={selectedOption} setSelectedOption={setSelectedOption} setMapLocation={setMapLocation} setIsSearchMode={setIsSearchMode} marginTop={marginTop} myHotples={myHotples} adminHotples={adminHotples} setSelectedHotple={setSelectedHotple} activeMenu={activeMenu} setActiveMenu={setActiveMenu}/>}
      {(activeMenu=='search' || activeMenu == 'home') && searchButtonFlag &&
        <div className="buttonMap_searchBT" onClick={()=>whenSearchButtonClicked()}>
          <img className="iconrefresh_searchBT" alt="" src="images/refresh.svg" />
          <div className="label_searchBT">현 지도에서 탐색</div>
        </div>
      }

      <div className="locationMapControl" onClick={()=>moveToCurrentLocation()}>
        <img className="iconmyLocation" alt="" src="images/my_location.svg" />
      </div>

      <div className="zoomMapControl">
        <div className="plusButton" onClick={()=>increaseZoomLevel()}>
          <img className="iconplusLine" alt="" src="images/plus_line.svg" />
        </div>
        <div className="zoombuttondivider" />
          <div className="minusButton" onClick={()=>decreaseZoomLevel()}>
        <img className="iconminusLine" alt="" src="images/minus_line.svg" />
        </div>
      </div>
    </div>
  );
};

export default NaverMap;
